module.exports = __webpack_public_path__ + "static/media/Youtube_Logo.1169a5e0.svg";